export const FEETYPESELECTS = [
  {
    name: 'Porcento',
    value: 'Percent',
  },
  {
    name: 'Fixo',
    value: 'Fixed',
  },
];

export const DISTRIBUTORUSERTYPE = [
  {
    name: 'Master',
    value: 'Master',
  },

  {
    name: 'Básico',
    value: 'Básico',
  },
];

export const USERSTATUS = [
  {
    name: 'Ativo',
    value: 'Ativo',
  },

  {
    name: 'Inativo',
    value: 'Inativo',
  },
];

export const MAPPINGTYPE = [
  {
    name: 'Nome',
    value: 'by_name',
  },
  {
    name: 'Ordem',
    value: 'by_order',
  },
];

export const FREIGHT_STATUS_FILTER = [
  { value: 'Todos', name: 'Todos' },
  { value: 'Entregue', name: 'Entregue' },
  { value: 'A caminho', name: 'A caminho' },
  { value: 'Desconhecido', name: 'Desconhecido' },
  { value: 'Procurando por motorista', name: 'Procurando por motorista' },
  { value: 'Pedido aguardando coleta', name: 'Pedido aguardando coleta' },
  { value: 'Com problema', name: 'Com problema' },
  { value: 'Criado', name: 'Criado' },
  { value: 'Cancelado', name: 'Cancelado' },
  { value: 'Processando', name: 'Processando' },
];
export const DELIVERY_STATUS_FILTER = [
  { value: 'Todos', name: 'Todos' },
  { value: 'Entregue', name: 'Entregue' },
  { value: 'Aguardando', name: 'Aguardando' },
  { value: 'Com problema', name: 'Com problema' },
];

export const DRIVER_STATUS_FILTER = [
  { value: 'Todos', name: 'Todos' },
  { value: 'Ativo', name: 'Ativo' },
  { value: 'Aprovação pendente', name: 'Aprovação pendente' },
  { value: 'Registro incompleto', name: 'Registro incompleto' },
];

export const DRIVERSTATUS = [
  { value: 'Ativo', name: 'Ativo' },
  { value: 'Aprovação pendente', name: 'Aprovação pendente' },
  { value: 'Registro incompleto', name: 'Registro incompleto' },
];

export const VEHICLETYPE = [
  {
    value: 'VUC(Veículo Urbano de Carga)',
    name: 'VUC(Veículo Urbano de Carga)',
  },
  { value: 'Utilitário', name: 'Utilitário' },
  { value: 'Caminhão toco', name: 'Caminhão toco' },
  { value: 'Caminhão truck', name: 'Caminhão truck' },
  { value: 'Bitruck', name: 'Bitruck' },
  { value: 'Carreta simples', name: 'Carreta simples' },
  { value: 'Carreta LS', name: 'Carreta LS' },
  { value: 'Bitrem', name: 'Bitrem' },
];

export const REASON_REFUSAL = [
  {
    value: 'RG inválido',
    name: 'RG inválido',
  },
  {
    value: 'Modelo,ano ou placa incorreto',
    name: 'Modelo,ano ou placa incorreto',
  },
  {
    value: 'Data de nascimento incorreta',
    name: 'Data de nascimento incorreta',
  },
  {
    value: 'CPF inválido',
    name: 'CPF inválido',
  },
  {
    value: 'Nome inválido',
    name: 'Nome inválido',
  },
  {
    value: 'Email inválido',
    name: 'Email inválido',
  },
  {
    value: 'Número de telefone inválido',
    name: 'Número de telefone inválido',
  },
  {
    value: 'CPF não condizente',
    name: 'CPF não condizente',
  },
  {
    value: 'RG não condizente',
    name: 'RG não condizente',
  },
  {
    value: 'Foto pessoal inválida',
    name: 'Foto pessoal inválida',
  },
  {
    value: 'Carteira de Habilitação inválida',
    name: 'Carteira de Habilitação inválida',
  },
  {
    value: 'Foto da Carteira de Habilitação inválida',
    name: 'Foto da Carteira de Habilitação inválida',
  },
  {
    value: 'Peso do veículo inválido',
    name: 'Peso do veículo inválido',
  },
  {
    value: 'Capacidade de carga inválida',
    name: 'Capacidade de carga inválida',
  },
  {
    value: 'Comprimento do baú inválido',
    name: 'Comprimento do baú inválido',
  },
  {
    value: 'Largura do baú inválido',
    name: 'Largura do baú inválido',
  },
  {
    value: 'Tipo do veículo invalido',
    name: 'Tipo do veículo invalido',
  },
  {
    name: 'Foto da traseira do veículo invalida',
    value: 'Foto da traseira do veículo invalida',
  },
  {
    name: 'Foto da frente do veículo invalida',
    value: 'Foto da frente do veículo invalida',
  },
  {
    name: 'Foto do lado esquerdo do veículo invalida',
    value: 'Foto do lado esquerdo do veículo invalida',
  },
  {
    name: 'Foto do lado direito do veículo invalida',
    value: 'Foto do lado direito do veículo invalida',
  },
];
